import { format, parse } from "date-fns";
import { enUS, fr } from "date-fns/locale";

import { dateUtils } from "@whoosh/utilities";

export const formatEventDate = (date: string, locale: string) => {
  if (!date) {
    return "";
  }

  const dateFormat = locale === "fr" ? "EEEE d MMMM" : "EEEE, MMM do";

  return format(parse(date, "yyyy-MM-dd", new Date()), dateFormat, {
    locale: locale === "fr" ? fr : enUS,
  });
};

export function formatEventTime({
  displayTime,
  startAt,
  endAt,
}: {
  displayTime: string | null | undefined;
  startAt: string | null | undefined;
  endAt: string | null | undefined;
}) {
  return displayTime
    ? displayTime
    : `${dateUtils.formatHHMM(startAt || "")} - ${dateUtils.formatHHMM(
        endAt || ""
      )}`;
}
